import { IPill } from './Pill.interfaces';
import { Pill } from './Pill';

export default Pill as any as any as React.StatelessComponent<IPill>;
